var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 15.4634C13.3537 15.4634 13.2075 15.4297 13.0725 15.3509L3.13872 9.60219C2.74497 9.36594 2.59872 8.84844 2.83497 8.44344C3.07122 8.03844 3.58872 7.90344 3.99372 8.13969L13.5 13.6409L22.95 8.17344C23.355 7.93719 23.8725 8.08344 24.1087 8.47719C24.345 8.88219 24.1987 9.39969 23.805 9.63594L13.9387 15.3509C13.7925 15.4184 13.6462 15.4634 13.5 15.4634Z",
    fill: "#999999",
    stroke: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 25.6569C13.0387 25.6569 12.6562 25.2744 12.6562 24.8131V14.6094C12.6562 14.1481 13.0387 13.7656 13.5 13.7656C13.9612 13.7656 14.3438 14.1481 14.3438 14.6094V24.8131C14.3438 25.2744 13.9612 25.6569 13.5 25.6569Z",
    fill: "#999999",
    stroke: "#999999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5001 26.0938C12.5101 26.0938 11.5313 25.88 10.7551 25.4525L4.74759 22.1112C3.11634 21.2112 1.84509 19.04 1.84509 17.1725V10.8162C1.84509 8.94875 3.11634 6.78875 4.74759 5.8775L10.7551 2.5475C12.2963 1.6925 14.7038 1.6925 16.2451 2.5475L22.2526 5.88875C23.8838 6.78875 25.1551 8.96 25.1551 10.8275V17.1838C25.1551 19.0513 23.8838 21.2112 22.2526 22.1225L16.2451 25.4525C15.4688 25.88 14.4901 26.0938 13.5001 26.0938ZM13.5001 3.59375C12.7913 3.59375 12.0938 3.74 11.5763 4.02125L5.56884 7.3625C4.48884 7.95875 3.53259 9.57875 3.53259 10.8162V17.1725C3.53259 18.41 4.48884 20.03 5.56884 20.6375L11.5763 23.9788C12.6001 24.5525 14.4001 24.5525 15.4238 23.9788L21.4313 20.6375C22.5113 20.03 23.4676 18.4212 23.4676 17.1725V10.8162C23.4676 9.57875 22.5113 7.95875 21.4313 7.35125L15.4238 4.01C14.9063 3.74 14.2088 3.59375 13.5001 3.59375Z",
    fill: "#999999",
    stroke: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.54825908c702d3f684619c01564ddbb8.svg";
export { ForwardRef as ReactComponent };